<template lang="pug">
v-card#chatWindow.pa-0.sdo-chat(
  color="transparent"
  dark flat
)
  v-sheet.overflow-auto.scroll.px-2.pb-4.sdo-chat__window(
    color="transparent" max-height="200" height="100%"
  )
    .fill-height.d-flex.align-center.justify-center(v-if="loading.messages")
      v-progress-circular(
        indeterminate
        color="white"
        size=70
      )
    template(v-else-if="messages.length")
      v-spacer
      template(
        v-for="(group, day) in groupedMessages"
      )
        .my-2.d-flex.align-center.justify-center(
          :key="day"
        )
          v-chip(color="#ffffff4d" dark).px-10 {{ day }}
        sdo-chat-message(
          v-for="(message, idx) in group"
          :key="`${day}-${idx}`"
          :message="message"
        )
    .fill-height.d-flex.align-center.justify-center(v-else)
      .text-center.white--text
        strong Здесь пока еще нет сообщений...
  v-card-actions.px-0
    v-textarea(
      ref="chatInput"
      v-model="text"
      filled
      rounded
      auto-grow
      outlined
      rows="0"
      :placeholder="loading.send ? 'Отправка сообщения...' : 'Наберите сообщение'"
      append-icon="mdi-send"
      single-line
      autofocus
      hide-details
      :disabled="loading.send"
      @keydown.enter.exact.prevent="sendMessage"
      @keydown.enter.shift.exact.prevent="text += '\\n'"
      @click:append="sendMessage"
    )
</template>
<script>
import { groupBy } from 'lodash';
import { parseISO, format } from 'date-fns';
import Chat from '@/models/list/Chat';
import SdoChatMessage from '@/modules/Chat/components/SdoChatMessage.vue';

export default {
  components: { SdoChatMessage },
  props: {
    contract: { type: Object, required: true },
  },
  provide() {
    return {
      chat: this.chat,
    };
  },
  data() {
    return {
      text: '',
      chat: null,
      messages: [],
      loading: {
        chat: true,
        messages: true,
        send: false,
      },
    };
  },
  computed: {
    canSendMessage() {
      return !!this.text;
    },
    groupedMessages() {
      // group messages by day
      return groupBy(this.messages, (message) => {
        const date = format(parseISO(message.created_at), 'yyyy-MM-dd');
        return this.$dp.dateprintRelative(date, new Date());
      });
    },
  },
  mounted() {
    this.getChatRoom();
  },
  methods: {
    async sendMessage() {
      const bufferText = this.text;
      if (this.canSendMessage) {
        this.loading.send = true;
        this.text = null;
        await this.chat.sendMessage({ text: bufferText });
        this.loading.send = false;
        this.focusInput();
      }
    },
    focusInput() {
      const { chatInput } = this.$refs;
      setTimeout(() => chatInput.$refs.input.focus(), 10);
    },
    onMessage(val) {
      this.messages.push(val);
    },
    async getChatRoom() {
      const room = await this.$api.contracts.getRoomContract(this.contract?.id);
      this.chat = new Chat(room.data.data);
      this.chat.bindOnMessage((message) => this.onMessage(message));
      this.initMessages();
      this.loading.chat = false;
    },
    async initMessages() {
      this.loading.messages = true;
      this.messages = await this.chat.getHistory();
      this.scrollToBottom({ immediately: false });
      this.loading.messages = false;
    },
    scrollToBottom({ immediately } = {}) {
      const duration = immediately ? 0 : 300;
      const chatWindow = document.getElementById('chatWindow');
      this.$vuetify.goTo(chatWindow.scrollHeight - 110, { container: chatWindow, duration });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.sdo-chat {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 100%;

  &--loading {
    width: 300px;
    height: 300px;
    border-radius: 40px;
    background-color: rgba(white, .5);
  }

  &__window {
    overflow: hidden auto;
    display: flex;
    flex-grow: 1;
    flex-direction: column;

    &::-webkit-scrollbar {
      background-color: transparent;
      width: 5px;
    }

    &:hover {
      @include sdo-light-scrollbar();
    }
  }

  &__input {
    flex-grow: 0;
  }
}
</style>
